// extracted by mini-css-extract-plugin
export default {"reveal":"Reveal_reveal__5Qo8M","up":"Reveal_up__EjLnB","left":"Reveal_left__6t8uD","right":"Reveal_right__kTgj4","none":"Reveal_none__YtEwe","visible":"Reveal_visible__+bPbp"};